module.exports = __webpack_public_path__ + "static/media/google-play.5a523b8f.svg";